import {
    ControlHealthFilterType,
    ControlHealthFilters,
    DEFAULT_CONTROL_HEALTH_FILTERS,
} from "./types";

interface FilterSpec {
    type: ControlHealthFilterType;
    isActive: (filters: ControlHealthFilters) => boolean;
    /** The value that clears this filter. */
    cleared: Partial<ControlHealthFilters>;
}

/** Everything the panel needs per filter category, in display order. Matches the dashboard's order. */
const FILTER_SPECS: FilterSpec[] = [
    {
        type: "ControlPrograms",
        isActive: (filters) => filters.controlPrograms.length > 0,
        cleared: { controlPrograms: [] },
    },
    {
        type: "Tags",
        isActive: (filters) => filters.tags.length > 0,
        cleared: { tags: [] },
    },
    {
        type: "Entities",
        isActive: (filters) => filters.entities.length > 0,
        cleared: { entities: [] },
    },
];

/** Entities are only a thing for orgs running Entity Management. */
export function getEnabledFilterTypes(
    controlEntitiesEnabled: boolean
): ControlHealthFilterType[] {
    return FILTER_SPECS.filter(
        ({ type }) => type !== "Entities" || controlEntitiesEnabled
    ).map(({ type }) => type);
}

export function clearedFilterValue(
    filterType: ControlHealthFilterType
): Partial<ControlHealthFilters> {
    return specFor(filterType).cleared;
}

/** Which filter rows to show — one per filter that has a value. */
export function deriveFilterTypes(
    filters: ControlHealthFilters
): ControlHealthFilterType[] {
    return FILTER_SPECS.filter((spec) => spec.isActive(filters)).map(
        ({ type }) => type
    );
}

export function countActiveFilters(filters: ControlHealthFilters): number {
    return deriveFilterTypes(filters).length;
}

export function isDateRangePresetActive(
    filters: ControlHealthFilters
): boolean {
    return (
        filters.dateRangePreset.type !==
        DEFAULT_CONTROL_HEALTH_FILTERS.dateRangePreset.type
    );
}

function specFor(filterType: ControlHealthFilterType): FilterSpec {
    const spec = FILTER_SPECS.find(({ type }) => type === filterType);
    if (spec === undefined) {
        throw new Error(`No filter spec for ${filterType}`);
    }
    return spec;
}
